export const propertyInstructionMapper = (data) => {
    return {
        id: data.id,
        contentIt: data.contentIt,
        contentEn: data.contentEn,
        category: data.category,
        isInherited: data.isInherited,
    }
}